const SKIPPED_TAGS = new Set([
  'img',
  'iframe',
  'video',
  'audio',
  'embed',
  'object',
  'script',
  'style',
  'svg',
])

const BLOCK_TAGS = new Set([
  'p',
  'div',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'li',
  'tr',
  'blockquote',
])

const nodeToPlainText = (node: Node): string => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? ''
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return Array.from(node.childNodes).map(nodeToPlainText).join('')
  }

  const element = node as Element
  const name = element.tagName.toLowerCase()
  if (SKIPPED_TAGS.has(name)) return ''
  if (name === 'br') return '\n'

  const inner = Array.from(element.childNodes).map(nodeToPlainText).join('')
  if (BLOCK_TAGS.has(name)) return inner.endsWith('\n') ? inner : `${inner}\n`
  return inner
}

export const htmlToPlainText = (html?: string | null): string => {
  if (!html) return ''

  const doc = new DOMParser().parseFromString(html, 'text/html')
  return nodeToPlainText(doc.body)
    .trim()
    .replace(/\n{3,}/g, '\n\n')
}
